import React, { Component } from "react";
import { connect } from "react-redux";
import { Router, Route, Switch } from "react-router-dom";
import { Login } from "./components/login/login";
import { AplicationForm } from "./components/form/aplicationForm";
import { history } from "./_helpers/history";
import { PrivateRoute } from "./_helpers/privateRoute";
import { Page404 } from "./components/404/404";
import { Header } from "./components/header/header";
import { Footer } from "./components/footer/footer";
import { Aplications } from "./components/aplications/aplications";
class App extends Component {
  constructor(props) {
    super(props);
    const { dispatch } = this.props;
    history.listen((location, action) => {});
    sessionStorage.removeItem("tabHasChanges");
  }
  render() {
    const router = (
      <Switch>
        <PrivateRoute
          exact
          path="/job-application/:hash/personal-info"
          component={AplicationForm}
          tab="1"
        />
        <PrivateRoute
          exact
          path="/job-application/:hash/preferences"
          component={AplicationForm}
          tab="2"
        />
        <PrivateRoute
          exact
          path="/job-application/:hash/qualification"
          component={AplicationForm}
          tab="3"
        />
        <PrivateRoute
          exact
          path="/job-application/:hash/experience"
          component={AplicationForm}
          tab="4"
        />
        <PrivateRoute
          exact
          path="/job-application/:hash/driver-qualification"
          component={AplicationForm}
          tab="5"
        />
        <PrivateRoute
          exact
          path="/job-application/:hash/legal-remarks"
          component={AplicationForm}
          tab="6"
        />
        <PrivateRoute
          exact
          path="/job-application/applications"
          component={Aplications}
          tab="6"
        />
        <PrivateRoute path="/" component={Login} />
        /<Route component={Page404} />
      </Switch>
    );
    var page = window.location.href.split("/").pop();
    return (
      <Router history={history}>
        <div className="aplcn-page-container-main-wrapper">
          <Header />
          {router}
          <Footer />
          {/* {"" !== page && <Footer />} */}
        </div>
      </Router>
    );
  }
}
function mapStateToProps(state) {
  return state;
}
const connectedApp = connect(mapStateToProps)(App);
export { connectedApp as App };
